
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fr/blog",
      function () {
        return require("private-next-pages/fr/blog/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fr/blog"])
      });
    }
  